var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.2702C0 30.4872 0.7619 28.5866 2.2857 26.5685L3.51878 24.9815L25.2329 0H39.9697V8.46431C39.9697 10.6 38.7567 13.1373 36.3306 16.0763L14.1954 39.9997H0V32.2702ZM0 5.17264C0 2.6451 0.3208 0.920886 0.9624 0H19.3683L3.90975 16.0763H3.0075C1.0025 14.9399 0 11.3053 0 5.17264ZM39.9697 34.7977C39.9697 37.3645 39.6689 39.0985 39.0674 39.9997H20.9322L36.9923 23.0123C38.6564 23.9332 39.6188 26.1277 39.8795 29.5957C39.9597 30.6733 39.9998 31.8097 39.9998 33.0049L39.9697 34.7977Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.17264C0 2.6451 0.3208 0.920886 0.9624 0H19.3683L3.90975 16.0763H3.0075C1.0025 14.9399 0 11.3053 0 5.17264ZM39.9697 34.7977C39.9697 37.3645 39.6689 39.0985 39.0674 39.9997H20.9322L36.9923 23.0123C38.6564 23.9332 39.6188 26.1277 39.8795 29.5957C39.9597 30.6733 39.9998 31.8097 39.9998 33.0049L39.9697 34.7977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/Footer-logo.02a56f96c8a8072d1c2f86f319720ef2.svg";
export { ForwardRef as ReactComponent };